import * as React from 'react';
import { BaseProps, Classes } from '../index';
import classNames from 'classnames';
export type NoHeaderGroupContainer = BaseProps & {
  title?: React.ReactNode | string;
};
export const NoHeaderGroupContainer: React.FC<NoHeaderGroupContainer> = ({
  className,
  style,
  children,
}) => {
  return (
    <div
      className={classNames(className, Classes.NO_HEADER_GROUP_CONTAINER)}
      style={style}
    >
      <div className={Classes.GROUP_CONTAINER_BODY}>{children}</div>
    </div>
  );
};
